export default __webpack_public_path__ + "static/media/ITCAVANTGARDESTD-BK.55971260.ttf";